import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const isAuth = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  return {
    loggedIn: !!token,
    token,
    role,
  };
};

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(isAuth());


  const login = (token, role) => {
    localStorage.setItem("token", token);
    localStorage.setItem("role", role);
    setAuth({
      loggedIn: true,
      token,
      role,
    });
  };

  const logout = () => {
    const role = auth.role;

    localStorage.removeItem("token");
    localStorage.removeItem("role");

    setAuth({
      loggedIn: false,
      token: null,
      role: null,
    });

    return role; // Return the role to allow redirection based on it in the calling component 
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: auth.loggedIn,
        token: auth.token,
        role: auth.role,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
